import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-show-errors',
  templateUrl: './show-errors.component.html',
  styleUrls: ['./show-errors.component.scss'],
})
export class ShowErrorsComponent implements OnInit {
  @Input() isDirty: boolean = false;
  @Input() ctrl: any;
  @Input() parentMargin: string | null = '15px';
  @Input() setErrorMessage: {} = {};
  @Input() requiredMesg: string = 'Field is required';
  @Input() patternMesg: string = 'Pattern not valid';
  ERROR_MESSAGE: ValidationErrors = {
    required: () => this.requiredMesg,
    // maxAge: () => `Age should be greather then 18.`,
    pattern: () => this.patternMesg,
    minlength: (par: { requiredLength: number, actualLength: number }) => `Min ${par.requiredLength} characters is required`,// {minlength: {requiredLength: 3, actualLength: 2}}
    maxlength: (par: { requiredLength: number, actualLength: number }) => `Max ${par.requiredLength} characters are allowed`,// {maxlength: {requiredLength: 5, actualLength: 7}}
    min: (min: { min: number, actual: number }) => `Could you please ensure that the figure is greater than ${min.min}?`,// {min: {min: 3, actual: 2}}  `Min ${min.min} is required.`
    max: (max: { max: number, actual: number }) => `Could you please ensure that the figure is less than ${max.max}?`,// {min: {min: 3, actual: 2}}  `Min ${min.min} is required.`
    ptDate: () => 'Enter Valid Date',
    specialcharacters: () => `special characters not allowed`,
    // email: () => `Please Enter Valid Email Id`
    dynError: (v: any) => `${v}`
  };

  constructor(
    private ele: ElementRef,
    private _Renderer2: Renderer2
  ) {
    if ((this.ele.nativeElement as HTMLElement).parentElement) {
      this._Renderer2.setStyle((this.ele.nativeElement as HTMLElement).parentElement, 'position', 'relative');
    }
  }

  ngOnInit() {

    if (this.parentMargin && (this.ele.nativeElement as HTMLElement).parentElement) {
      this._Renderer2.setStyle((this.ele.nativeElement as HTMLElement).parentElement, 'margin-bottom', this.parentMargin);
    }


    // this.ERROR_MESSAGE = assign({}, this.ERROR_MESSAGE, this.setErrorMessage);
    this.ERROR_MESSAGE = {
      ...this.ERROR_MESSAGE,
      ...this.setErrorMessage
    };
  }

  shouldShowErrors() {
    // return this.ctrl && this.ctrl.errors && this.ctrl.touched;
    if (this.isDirty) {
      return this.ctrl && this.ctrl.errors && (this.ctrl.dirty || this.ctrl.touched);
    } else {
      return this.ctrl && this.ctrl.errors && this.ctrl.touched;
    }
  }

  listOfErrors() {
    return Object.keys(this.ctrl.errors).map((err: any) => {

      return this.ERROR_MESSAGE[err] ? this.ERROR_MESSAGE[err](this.ctrl.getError(err)) : this.ctrl.getError(err);
    });
  }
  getTypeOf(error: any) {
    return typeof error
  }
}
